export default "__VITE_ASSET__D1V7A1db__"